module.exports = __webpack_public_path__ + "static/media/icon-facebook.4a1c2025.png";